<template>
  <b-navbar toggleable="lg" class="fixed-top pr-0 pt-0 pb-0">
    <b-navbar-brand>
      <img :class="haveParameters ? 'mr-2' : ''" :alt="$t('title')" src="/static/img/logo_full.png">
      <template v-if="!$helper.isLegacy">
        <img
          v-if="haveParameters"
          :alt="get().parameters.company.name"
          :src="$ajax.getUploadsUri(get().parameters.logo)"
        >
      </template>
    </b-navbar-brand>
    <b-navbar-toggle target="nav_collapse">
      <span class="navbar-toggler-icon" />
    </b-navbar-toggle>
    <b-collapse id="nav_collapse" is-nav>
      <b-navbar-nav :class="`ml-auto ${navbarClasses} align-items-center h-100 pl-3`">
        <li v-for="(item, idx) in menu" :key="idx" class="nav-item d-flex align-items-center mr-3">
          <router-link
            v-if="user() && !item.isExternal"
            :to="item.link"
            :exact="isOnSubTest(item)"
            :target="item.target"
            :class="['text-center connected nav-link', {'router-link-active': $route.name === item.link.name}]"
          >
            <template v-if="item.icon">
              <i :class="`ti ti-fw ti-lg ${item.icon}`" />
              <br>
            </template>
            {{ $t(item.label) }}
          </router-link>
          <a v-else
             :href="item.link"
             class="text-center"
             target="_blank"
          >
            <template v-if="item.icon">
              <i :class="`ti ti-fw ti-lg ${item.icon}`" />
              <br>
            </template>
            {{ $t(item.label) }}
          </a>
        </li>
        <li v-if="user()" class="nav-item logout h-100">
          <router-link
            :to="{ name: 'logout' }"
            class="logout-link nav-link text-white d-flex align-items-center h-100 bg-primary justify-content-center"
          >
            <i class="ti ti-fw ti-off ti-2x" />
          </router-link>
        </li>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
  export default {
    name: 'MainMenuComponent',
    data() {
      return {
        disconnectMenu: [{
          name: 'pcie',
          label: 'menu.disconnect.site',
          icon: 'ti-web',
          link: 'https://www.icdl.quebec/',
        }, {
          name: 'demo',
          label: 'menu.disconnect.demo',
          icon: 'ti-paper-board',
          link: this.$helper.playerFullUri(null, { player: this.get().enums.player.demo12 }),
        }, {
          name: 'help',
          label: 'menu.disconnect.help',
          icon: 'ti-play',
          link: 'https://www.youtube.com/watch?v=sM5peV4yUAc',
        }],
        connectMenu: [{
          label: 'menu.connect.dashboard',
          link: { name: 'dashboard' },
        }, {
          label: 'menu.connect.test',
          link: { name: 'evaluation' },
        }, {
          label: 'menu.connect.exam',
          link: { name: 'completed_test' },
        }, {
          label: 'menu.connect.profile',
          link: { name: 'account' },
        }],
        legacyMenu: [{
          label: 'menu.connect.dashboard',
          link: { name: 'dashboard' },
        }, {
          label: 'legacy.menu.evaluation',
          link: { name: 'evaluation' },
        }, {
          label: 'legacy.menu.certification',
          link: { name: 'certification' },
        }, {
          label: 'legacy.menu.preparation',
          link: { name: 'preparation' },
        }, {
          label: 'legacy.menu.already_passed_test',
          link: { name: 'completed_test' },
        }, {
          label: 'menu.connect.profile',
          link: { name: 'account' },
        }],
      };
    },
    computed: {
      haveParameters() {
        return !this._.isUndefined(this.get().parameters);
      },
      menu() {
        if (this.user()) {
          if (this.$helper.isLegacy) {
            this.toggleElearningUrl();
            return this.legacyMenu;
          }

          return this.connectMenu;
        }

        return this.disconnectMenu;
      },
      navbarClasses() {
        if (this.user()) {
          return 'justify-content-between';
        }

        return 'justify-content-end';
      },
    },
    mounted() {
      if (!this.$helper.canShowPlayerDemo) {
        this.$delete(
          this.disconnectMenu,
          this._.findIndex(this.disconnectMenu, { name: 'demo' }),
        );
      }

      if (!this.$helper.canShowHelpVideo) {
        this.$delete(
          this.disconnectMenu,
          this._.findIndex(this.disconnectMenu, { name: 'help' }),
        );
      }
    },
    methods: {
      toggleElearningUrl() {
        const index = this.legacyMenu.length - 1;
        let elearningAddr = '/elearning';
        if(this.$helper.isClientCenter)
        {

          elearningAddr = this.user().elearning_url;
        }
        const elearningUrl = elearningAddr;

        const elearningLink = {
          label: 'menu.connect.elearning_url',
          link: elearningUrl,
          isExternal: this.$helper.isClientCenter,
        };

        const elearningLinkIndex = this._.findIndex(this.legacyMenu, this._.pick(elearningLink, 'label'));

        if (elearningUrl && elearningLinkIndex === -1) {
          this.legacyMenu.splice(index, 0, elearningLink);
        } else if (!elearningUrl && elearningLinkIndex !== -1) {
          this.legacyMenu.splice(elearningLinkIndex, 1);
        }
      },
      isOnSubTest(item) {
        return item.link.name !== 'evaluation';
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '~@/scss/vars';

  .navbar {
    background-color: $white;
    height: $nav-height;

    .navbar-collapse,
    ul.navbar-nav,
    li.nav-item {
      height: 100%;
    }

    .nav-item {
      a {
        font-size: 1rem;
        text-decoration: none;
        color: $dark-grey;

        &.connected {
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        &.router-link-active:not(.logout-link) {
          position: relative;
          color: theme-color('primary');

          &:before {
            content: '';
            position: absolute;
            top: 15px;
            left: 0;
            right: 0;
            margin: auto;
            width: 10px;
            height: 10px;
            background-color: theme-color('primary');
            border-radius: 100%;
          }
        }
      }
    }

    .navbar-brand {
      height: 100%;
      border-right: 6px solid $extra-light-grey;
      padding-right: 2rem;
      display: flex;
      align-items: center;
      margin-right: 0;

      img {
        height: 55px;
      }
    }

    .logout {
      min-width: 90px;

      a {
        padding: 0 !important;
        height: 100%;

        &:hover {
          background-color: $secondary;
        }
      }
    }
  }

  @include media-breakpoint-down(md) {
    .navbar {
      .navbar-collapse {
        position: fixed;
        top: $nav-height;
        left: 0;
        right: 0;
        height: auto;

        .navbar-nav {
          padding: 0 !important;
          margin: 0 !important;
          height: unset !important;
          background-color: $white;

          li.nav-item {
            width: 100%;
            justify-content: center;

            &:not(.logout) {
              padding: 0.5rem;
            }

            &.logout {
              a {
                padding: 1rem !important;
              }
            }

            a::before {
              content: unset;
            }
          }
        }
      }
    }
  }
</style>
